import styled from 'styled-components';

import vars from 'variables';

import vertical from 'assets/Common/Borders/vertical.svg';
import background from 'assets/Common/JoinTheCommunities/background.png';
import smaller from 'assets/Common/JoinTheCommunities/background-smaller.png';

const Root = styled.div`
  position: relative;

  div.bg {
    position: relative;
    background-repeat: no-repeat;
    z-index: 0;
  }

  div.bg.smaller {
    position: absolute;
    background-image: url(${smaller});
    background-position: 0 -30px;
    z-index: -1;
  }

  div.bg.smallest {
    position: absolute;
    opacity: 0.15;
    border-radius: 20px;
    z-index: -2;
  }

  h2 {
    text-align: center;
  }

  ul {
    margin-top: 25px;
    display: flex;
    justify-content: center;
  }

  li {
    margin: 0 10px;
  }

  ${vars.desktop.mediaQuery} {
    & {
      padding-bottom: 115px;
    }

    div.bg {
      padding: 55px 140px 45px;
      background-image: url(${vertical}),
                        url(${vertical}),
                        url(${vertical}),
                        url(${vertical}),
                        url(${background});
      background-position: 14% 40px,
                           28% 40px,
                           72% 40px,
                           86% 40px,
                           0 0;
      background-size: auto,
                       auto,
                       auto,
                       auto,
                       1442px 500px;
      border-radius: 30px;
    }

    div.bg.smaller {
      left: 50px;
      right: 50px;
      bottom: 87px;
    }

    div.bg.smallest {
      left: 85px;
      right: 85px;
      bottom: 68px;
    }

    h2 {
      font-size: 2.35rem;
      line-height: 120%;
    }
  }

  ${vars.mobile.mediaQuery} {
    & {
      padding: 35px 0px 30px;
    }

    div.bg {
      padding: 25px;
      background-image: url(${background});
      background-position: -300px 0;
      border-radius: 15px;
    }

    div.bg.smaller {
      left: 12px;
      right: 12px;
      bottom: 19px;
    }

    div.bg.smallest {
      left: 30px;
      right: 30px;
      bottom: 9px;
    }

    h2 {
      font-size: 0.95rem;
      letter-spacing: 0.5px;
      line-height: 130%;
    }

    ul {
      width: 200px;
      margin: 0 auto;
      margin-top: 15px;
      flex-wrap: wrap;
    }

    li {
      margin: 3px 7px;
      flex: 0;
    }

    br {
      display: none;
    }

    img {
      width: 40px;
    }
  }
`;

export { Root };
